import { DefineComponentProps } from 'utils'

type SizedBoxProps = {
  width?: number
  height?: number
}

export const SizedBox = defineComponent<SizedBoxProps>({
  props: DefineComponentProps<SizedBoxProps>(['width', 'height']),
  setup(props) {
    return () => <div style={{ width: `${props.width}px`, height: `${props.height}px` }} />
  },
})
